import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 17v-13l-5 3l-5 -3v13l5 3l5 -3","key":"svg-0"}]]

const IconBadge = createReactComponent('outline', 'badge', 'Badge', __iconNode);

export default IconBadge;